import { api_configuration } from "../../common";
import api_app = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;

export function isKeyProperty(definition: api_app.Ctext__type__property): boolean {
	return definition.parent.parent.parent.input.location().switch({
		root: () => false,
		collection: ($) => $.properties.key_property.ref === definition,
		group: () => false,
		state: () => false,
	});
}
